import { v7 as uuidv7 } from 'uuid'

import { isDevelopment, isStaging } from '@/lib/general-helpers'

const LOK_AID_COOKIE = 'lok_aid'
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60 // 1 year in seconds

const parseCookies = (): Record<string, string> => {
	if (typeof document === 'undefined') return {}
	return document.cookie.split(';').reduce(
		(acc, c) => {
			const [key, ...val] = c.trim().split('=')
			if (key) acc[key] = decodeURIComponent(val.join('='))
			return acc
		},
		{} as Record<string, string>,
	)
}

/**
 * Get the cookie domain for cross-subdomain tracking.
 * Uses same pattern as ClickIdTracker for consistency.
 */
export const getCookieDomain = (): string => {
	if (isDevelopment()) return ''
	if (isStaging()) return '.lokalise.cloud'
	return '.lokalise.com'
}

/**
 * Get or create the anonymous ID (lok_aid cookie).
 * This ID is shared with app.lokalise.com for identity stitching.
 */
export const getAnonymousId = (): string => {
	if (typeof document === 'undefined') return uuidv7()

	const cookies = parseCookies()
	if (cookies[LOK_AID_COOKIE]) {
		return cookies[LOK_AID_COOKIE]
	}

	const newId = uuidv7()
	const domain = getCookieDomain()
	const domainPart = domain ? `; domain=${domain}` : ''
	const secure = isDevelopment() ? '' : '; Secure'

	// biome-ignore lint/suspicious/noDocumentCookie: required for first-party analytics cookie
	document.cookie = `${LOK_AID_COOKIE}=${newId}; max-age=${COOKIE_MAX_AGE}; path=/${domainPart}; SameSite=Lax${secure}`

	return newId
}
